export default "__VITE_ASSET__BceKOtil__"